/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Faz o Arrive no Stop
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 25/03/2013
 */


Greenmile.Stop = Greenmile.Stop || {};

Greenmile.Stop.Arrive = function ({
    parentSelector = '#RouteSummary',
    successCallback
} = {}) {

    Greenmile.Stop.Base.call(this);
    this.blockOverlaySelector = '.mainContainer';

    this.getLayout = function () {

        const date = new Monet.Date.GeneralFunctions();
        const util = Greenmile.Stop.Util;
        const drivers = util.getParametersToTemplate('Greenmile.Stop.Arrive.driversList', 'driversList');
        const dateTimeField = util.getParametersToTemplate('Greenmile.Stop.Arrive.dateTimeFieldLabel', 'arriveTime',
            date.getCurrentDateAndTime());

        const layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": Monet.I18n.getResourcesByKey('Greenmile.Stop.Arrive.btnSave'),
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },


                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": [
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": dateTimeField.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": dateTimeField.name
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "id": dateTimeField.name,
                                                        "value": dateTimeField.value,
                                                        "name": dateTimeField.name,
                                                        "class": "datePicker"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": drivers.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": drivers.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": drivers.name,
                                                        "id": drivers.name
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": Monet.I18n.getResourcesByKey('Greenmile.Stop.Arrive.btnSave'),
                                                        "name": "btn_save_arrive_stop",
                                                        "id": "btn_save_arrive_stop",
                                                        "class": "btn",
                                                        "style": "width: 170px"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": Monet.I18n.getResourcesByKey('Greenmile.Stop.Arrive.btnExit'),
                                                        "name": "btn_exit_arrive_stop",
                                                        "id": "btn_exit_arrive_stop",
                                                        "class": "btn secondary",
                                                        "style": "width: 75px"
                                                    }
                                                }
                                            ],
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formArriveStopFormTemplate"
                    }
                }
            ]
        };
        return (new Monet.UI.LayoutGenerator(layout)).render();
    };

    this.createForm = function () {
        const date = new Monet.Date.GeneralFunctions();
        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        if (modalContainer) {

            modalContainer.appendChild(this.getLayout());
            date.setDateTimePicker('input[name="arriveTime"]');

        } else {
            new Monet.Exception.ReturnError(this,"No .popupFormContainer found.")
                .console();
        }


    };

    this.populateDriversList = function (drivers) {

        var undeliverableCodeElement = document.querySelector("#formArriveStopFormTemplate #driversList");
        var driverLabel = document.querySelector("label[for='driversList']");
        var error = null;

        if (typeof(drivers) !== "undefined") {

            if (drivers.length > 0) {

                driverLabel.style.display = 'block';

                undeliverableCodeElement.innerHTML = "";

                for (var i = 0, j = drivers.length; i < j; i++) {

                    var option = document.createElement("option");

                    option.value = drivers[i].driver.id;
                    option.text = drivers[i].driver.name;

                    undeliverableCodeElement.appendChild(option);

                }
            } else {
                driverLabel.style.display = 'none';
            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                "No collection loaded");
            error.console();

        }

    };

    this.addEventListenners = function () {

        var that = this,
            btnSave,
            btnExit,
            error;

        try {

            btnSave = document.querySelector("#formArriveStopFormTemplate #btn_save_arrive_stop");
            btnExit = document.querySelector("#formArriveStopFormTemplate #btn_exit_arrive_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doArrive();
            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No add event listenner to form.");
            error.console();

        }

    };

    this.doArrive = function () {

        var isValid = this.validateForm();
        var formDataJson = {};
        var that = this;
        var driverParameter = "/NoDriver";
        var error = null;

        if (isValid) {

            formDataJson = this.getFormValues();

            if (this.routeId) {
                if (this.stop) {
                    this.modalForm.toggleLoadingInModalBtn();

                    if (formDataJson.driverId) {
                        driverParameter = "/Driver?id=" + formDataJson.driverId;
                    }

                    const ajax = new Monet.Ajax();

                    const stopKey = this.stop.get("stop").key;
                    const parsedStopKey = Greenmile.Stop.Util.formatStopKey(stopKey);

                    ajax.url = `Route/${this.routeId}/Stop/${parsedStopKey}/Arrive${driverParameter}`;
                    ajax.method = 'POST';
                    ajax.data = '{"actualArrival": "' + formDataJson.stop.actualArrival + '"}';
                    ajax.success = (data) => {
                        if(parentSelector === '#RouteSummary') {
                            App.Forms.RouteSummaryStops.pagination.first = 0;
                            that.successCallback(data);
                        } else {
                            successCallback?.();
                        }
                        that.modalForm.closeModalWindow();
                    };
                    ajax.error = (data) => {
                        that.modalForm.toggleLoadingInModalBtn();
                        that.errorCallback(data);
                    };
                    ajax.send();

                } else {

                    error = new Monet.Exception.ReturnError(this,
                        "Stop can't be null");
                    error.console();
                }
            } else {

                error = new Monet.Exception.ReturnError(this,
                    "routeId can't be null");
                error.console();

            }
        }

    };

    this.getFormValues = function () {

        var arriveTimeField = document.querySelector('#formArriveStopFormTemplate input#arriveTime');
        var driver = document.getElementById("driversList");

        const formattedDate = Monet.Format.DateTime.parseLocaleToISOString(arriveTimeField.value);

        var objToSend = {
            stop: {
                actualArrival: formattedDate
            },
            driverId: driver.value
        };

        return objToSend;
    };

    this.validateForm = function () {

        var isValid = true;
        var error = null;
        var arriveDate = document.getElementById("arriveTime");
        var driversList = document.getElementById("driversList");
        var routeActualStart = this.stop.get('route').actualStart;
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formArriveStopFormTemplate';
        var arriveTimeTimeMili = null;
        var routeStartTimeMili = Monet.Format.DateTime.parse(routeActualStart).getTime();

        try {

            if (arriveDate.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "arrive_date",
                    "Stop.Arrive.cantArriveWhitouDateTime"
                );

                isValid = false;

            } else {
                try {

                    arriveTimeTimeMili = Monet.Format.DateTime.parseLocale(arriveDate.value).getTime();
                    if (arriveTimeTimeMili <= routeStartTimeMili) {

                        utils.showErrorMessage(
                            scopeMessage,
                            "date_before_route_and_stop",
                            "Stop.Arrive.ArriveMustBeAfterStartRoute"
                        );

                        isValid = false;

                    } else {

                        if (driversList.value === "" && driversList.parentNode.style.display !== "none") {

                            utils.showErrorMessage(
                                scopeMessage,
                                "driver",
                                "Stop.Arrive.cantArriveWhitouDriver"
                            );

                            isValid = false;

                        } else {
                            if (arriveTimeTimeMili >= new Date().getTime()) {

                                utils.showErrorMessage(
                                    scopeMessage,
                                    "driver",
                                    "Stop.Arrive.cantArriveInTheFuture"
                                );

                                isValid = false;

                            }
                        }

                    }
                } catch (e) {

                    isValid = false;

                    error = new Monet.Exception.ReturnError(this,
                        "It's not possible obtain object from json or object is malformed.");
                    error.console();

                }
            }
        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {

            scope.prepareToCreateForm();
            scope.createForm();
            scope.loadDriverData();
            scope.addEventListenners();

        };
    }(this);

    const init = function (scope) {

        return function (scope) {

            const selector = parentSelector;

            const options = {
                width: 280,
                height: 258
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scope.blockOverlaySelector);

        }(scope);

    };

    init(this);

};
